//#region Components
import UploadFileWithSteps from "components/UploadFileWithSteps/UploadFileWithSteps";
//#endregion

const ListSection = ({
    form, 
    changeField,
    errors, errorText,
    title, formatFile
}) => {
    const changeStudentsFileBase64 = (newFile) => {
        changeField({
            studentsFile: { ...newFile }
        }, {
            studentsFile: false
        });
    }
    return (
        <UploadFileWithSteps 
            title={title}
            description={
                <p>
                    Selecciona un archivo en formato <strong>.CSV o .xlsx (excel)</strong> que contenga las columnas del formato modelo, sigue los siguientes pasos:
                </p>
            }
            file={form.studentsFile}
            error={errors.studentsFile}
            errorText={errorText}
            onChange={changeStudentsFileBase64}
            formatFile={formatFile}/>
    );
}

export default ListSection;